<style lang="scss"></style>

<template>
  <Modal link="impress" title="Impressum">
    <b>Informationen zur Organisation</b>

    <p>
      Cope Performance Group GmbH<br />
      Hainburger Straße 33<br />
      1030 Wien
    </p>

    <p>
      Telefon: +43 1 601 17-0<br />
      Fax: +43 1 601 17-878<br />
      E-Mail: hello@copegroup.com
    </p>

    <b>Firmenbuchnummer</b>

    <p>FN 345338 a</p>

    <b>Firmenbuchgericht</b>

    <p>Handelsgericht Wien</p>

    <b>Behörde gem. ECG</b>

    <p>Magistratisches Bezirksamt für den 3. Wiener Gemeindebezirk</p>

    <b>Kammer</b>

    <p>Wirtschaftskammer Wien</p>

    <b>Anwendbare Vorschriften</b>

    <p>Österr. Gewerbeordnung (www.ris.bka.gv.at)</p>

    <b>UID-Nummer</b>

    <p>ATU 65634968</p>
  </Modal>
  <Modal link="privacy" title="Datenschutzerklärung">
    Informationen zur Datenverarbeitung finden Sie in Ihrer Mitarbeiter:innen-Datenschutzinformation, die Ihnen in der Regel gemeinsam mit Ihrem
    Dienstvertrag ausgehändigt wurde. Sie können diese aber auch jederzeit von Ihrem:Ihrer HR Business-Partner:in anfordern.
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Modal from './util/Modal.vue';

export default defineComponent({ components: { Modal } });
</script>
